<span
  class="app-status-badge"
  [ngClass]="[toneClass, sizeClass]"
  [attr.title]="tooltipText"
  [attr.aria-description]="tooltipText"
  >{{ displayLabel }}</span
>
